module.exports = __webpack_public_path__ + "static/img/capacitor_ceramico-1.818ead7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/capacitor_ceramico-1.svg
// module id = KD0s
// module chunks = 0